type LovableErrorOptions = {
  mechanism?: "manual" | "onerror" | "unhandledrejection" | "react_error_boundary";
  handled?: boolean;
  severity?: "error" | "warning" | "info";
};

type LovableEvents = {
  captureException?: (
    error: unknown,
    context?: Record<string, unknown>,
    options?: LovableErrorOptions,
  ) => void;
};

declare global {
  interface Window {
    __lovableEvents?: LovableEvents;
  }
}

export function reportLovableError(
  error: unknown,
  context: Record<string, unknown> = {},
  options: LovableErrorOptions = {},
) {
  if (typeof window === "undefined") return;
  const mechanism = options.mechanism ?? "react_error_boundary";
  window.__lovableEvents?.captureException?.(
    error,
    {
      source: mechanism,
      route: window.location.pathname,
      ...context,
    },
    {
      mechanism,
      handled: options.handled ?? false,
      severity: options.severity ?? "error",
    },
  );
  // Also surface to the browser console so failures are visible during local
  // dev even if the monitoring hook is not wired up.
  if (options.severity === "warning") {
    console.warn(error);
  } else {
    console.error(error);
  }
}
